/**
 * TODO: JQUERY UI usage, consider removing drag / drop functionality in favor of another implementantion if possible.
 * JQuery UI has a list of known vulnerabilities, but at the same time we are maintaining hard coded files in our codebase that utilize older JQuery UI APIs,
 * making it difficult to upgrade JQuery UI without breaking the drag and drop functionality elsewhere.
 * Moreover, as long as JQuery UI is used, we will be unable to completely remove JQuery from our codebase.
 *  */

import handleDocumentClick from '../../common/handle-document-click'
import showDropZone from '../../common/show-dropzone'

export default function () {
  let newExportFormIdsCount = 0

  const unsubscribers = []

  const openDocumentsModal = function (element) {
    const documentElement = $(element).find(
      '[data-behaviour~="export-select-from-documents"]'
    )

    if (documentElement.length > 0) {
      documentElement.on('click', handleDocumentClick)

      unsubscribers.push(() => {
        documentElement.off('click', handleDocumentClick)
      })

      documentElement.click()
    }
  }

  const receiveNewItem = function (event, ui) {
    const $newElement = $(ui.item.attr('data-url')).clone()
    $newElement.removeAttr('id')
    // specific for document
    $newElement.html(
      $newElement
        .html()
        .replace(/export-form-id/g, `n${newExportFormIdsCount++}`)
    )
    // end specific for document
    $newElement.show()
    const $exportList = $('[data-behaviour="export-list"]')
    const $droppedElement = $exportList.find('.ui-draggable')
    $droppedElement.replaceWith($newElement)
    // specific for document
    return openDocumentsModal($newElement)
  }
  // end specific for document

  const receiveMissingItem = function (event, ui) {
    const $missingDropZone = $(event.target)
    const $missingElement = $missingDropZone.closest('li')
    const $newElement = $(ui.draggable.attr('data-url')).clone()
    $newElement.removeAttr('id')
    // specific for document
    $newElement.html(
      $newElement
        .html()
        .replace(/export-form-id/g, `n${1 + newExportFormIdsCount++}`)
    )
    $newElement.addClass('element-from-placeholder')
    // end specific for document
    $newElement.show()
    $missingElement.replaceWith($newElement)
    // Remove the draggable otherwise it will be used by the sortable
    ui.draggable.remove()

    // specific for document
    $newElement
      .find('[data-behaviour~="select-document-file-title"]')
      .val($missingDropZone.data('missing-data').title)
    $newElement
      .find('[data-behaviour~="permanent-document-show-title-page"]')
      .prop('checked', $missingDropZone.data('missing-data').showTitlePage)
    $newElement
      .find('[data-behaviour~="permanent-document-ignore-export-margins"]')
      .prop(
        'checked',
        $missingDropZone.data('missing-data').ignoreExportMargins
      )
    // end specific for document

    $newElement
      .find('[id$="show_title_page"]')
      .prop('checked', $missingDropZone.data('missing-data').showTitlePage)
    $newElement
      .find('[id$="show_title_page_header"]')
      .prop(
        'checked',
        $missingDropZone.data('missing-data').showTitlePageHeader
      )
    $newElement
      .find('[id$="show_title_page_footer"]')
      .prop(
        'checked',
        $missingDropZone.data('missing-data').showTitlePageFooter
      )
    $newElement
      .find('[id$="_show_headers"]')
      .prop('checked', $missingDropZone.data('missing-data').showHeaders)
    $newElement
      .find('[id$="_show_footers"]')
      .prop('checked', $missingDropZone.data('missing-data').showFooters)

    return openDocumentsModal($newElement)
  }

  $('[data-behaviour="export-drag-item"]').draggable({
    connectToSortable: '[data-behaviour="export-list"]',
    helper: 'clone',
    revert: 'invalid',
    start() {
      return $('[data-behaviour="export-list"]').sortable(
        'option',
        'items',
        '[data-behaviour="export-element"]'
      )
    },
    stop() {
      return $('[data-behaviour="export-list"]').sortable(
        'option',
        'items',
        '[data-behaviour~="export-element"]'
      )
    },
  })

  // Ensures that missing elements are not sortable when dropping into them

  $('[data-behaviour="export-list"]').sortable({
    tolerance: 'pointer',
    handle: 'h4',
    forcePlaceholderSize: false,
    forceHelperSize: true,
    items: '[data-behaviour~="export-element"]',
    placeholder: 'export-list-item-placeholder',
    refreshPositions: true,
    helper(e, el) {
      const $helper = $(el).clone()
      $helper.find('.box-white').children().not('h4').remove()

      return $helper
    },
    start() {
      return $(this).sortable('refreshPositions')
    },
    stop() {
      return showDropZone()
    },
    receive(event, ui) {
      return receiveNewItem(event, ui)
    },
  })

  $('[data-behaviour="export-missing-dropzone"]').droppable({
    accept: '[data-behaviour="export-drag-item"]',
    tolerance: 'pointer',
    hoverClass: 'drop-hover',
    drop(event, ui) {
      return receiveMissingItem(event, ui)
    },
  })

  showDropZone()

  return () => {
    $('[data-behaviour="export-drag-item"]').draggable('destroy')
    $('[data-behaviour="export-list"]').sortable('destroy')
    $('[data-behaviour="export-missing-dropzone"]').droppable('destroy')

    unsubscribers.forEach((unsubscriber) => unsubscriber())
  }
}
